import * as _ from 'lodash';
export const displayPercent = (value: number) => (value !== 0 && value !== undefined && value !== null ? value * 100 : 0);
export const percent = (value: number) => (value !== 0 && value !== undefined && value !== null ? value / 100 : 0);
export const formatPoint = point => (_.isInteger(displayPercent(point)) ? displayPercent(point) : displayPercent(point).toFixed(2));

export const formatPercentTruncated = (value: number | string | null | undefined, decimals = 2) => {
  if (value === undefined || value === null || value === '') return '';

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return '';

  const factor = 10 ** decimals;
  const truncatedPercent = Math.trunc(numericValue * 100 * factor) / factor;

  return truncatedPercent.toFixed(decimals).replace(/\.?0+$/, '');
};
